import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const articleLinks = [
  { label: "Guia Definitivo 2026", slug: "artigo-hoobuy-spreadsheet" },
  { label: "Como Economizar", slug: "como-economizar-hoobuy" },
  { label: "Hoobuy é Seguro?", slug: "hoobuy-e-seguro" },
  { label: "Top 100 Produtos", slug: "top-100-produtos-hoobuy" },
  { label: "Hoobuy vs Pandabuy", slug: "hoobuy-vs-pandabuy" },
  { label: "Melhor Agente de Compra", slug: "melhor-agente-compra" },
  { label: "Guia de Sneakers", slug: "guia-sneakers-hoobuy" },
  { label: "Guia de Streetwear", slug: "guia-streetwear-hoobuy" },
  { label: "Guia de Acessórios", slug: "guia-acessorios-hoobuy" },
  { label: "Dicas Compra Segura", slug: "dicas-compra-segura" }
];

export default function Navbar() {
  const [catDropdownOpen, setCatDropdownOpen] = useState(false);
  const [guidesDropdownOpen, setGuidesDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileGuidesOpen, setMobileGuidesOpen] = useState(false);
  const catRef = useRef<HTMLDivElement>(null);
  const guidesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (catRef.current && !catRef.current.contains(e.target as Node)) {
        setCatDropdownOpen(false);
      }
      if (guidesRef.current && !guidesRef.current.contains(e.target as Node)) {
        setGuidesDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-secondary-200/60">
      <nav className="flex items-center justify-between h-[72px] px-4 md:px-8 lg:px-16 max-w-[1440px] mx-auto">
        {/* Brand */}
        <Link
          to="/"
          className="text-foreground-950 font-heading text-lg md:text-xl font-bold whitespace-nowrap cursor-pointer flex-shrink-0"
        >
          Hoobuy Spreadsheet
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-2 lg:gap-3">
          {/* Home */}
          <Link
            to="/"
            className="flex items-center gap-1.5 h-10 px-4 rounded-full text-sm font-medium text-foreground-700 hover:bg-secondary-100 cursor-pointer transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line text-sm w-4 h-4 flex items-center justify-center"></i>
            Home
          </Link>

          {/* Shopping Guides Dropdown */}
          <div className="relative" ref={guidesRef}>
            <button
              onClick={() => {
                setGuidesDropdownOpen(!guidesDropdownOpen);
                setCatDropdownOpen(false);
              }}
              className={`flex items-center gap-1.5 h-10 px-4 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                guidesDropdownOpen
                  ? "bg-accent-100 text-accent-700"
                  : "text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              <i className="ri-book-open-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Guias de Compra
              <i className={`ri-arrow-down-s-line text-sm w-4 h-4 flex items-center justify-center transition-transform duration-200 ${guidesDropdownOpen ? "rotate-180" : ""}`}></i>
            </button>
            {guidesDropdownOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-white rounded-2xl border border-secondary-200 overflow-hidden shadow-lg max-h-[420px] overflow-y-auto">
                {articleLinks.map((a) => (
                  <Link
                    key={a.slug}
                    to={`/guia/${a.slug}`}
                    className="flex items-center gap-2 px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 cursor-pointer transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    <i className="ri-article-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                    {a.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Categories Dropdown */}
          <div className="relative" ref={catRef}>
            <button
              onClick={() => {
                setCatDropdownOpen(!catDropdownOpen);
                setGuidesDropdownOpen(false);
              }}
              className={`flex items-center gap-1.5 h-10 px-4 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                catDropdownOpen
                  ? "bg-secondary-100 text-foreground-950"
                  : "text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              <i className="ri-list-check text-sm w-4 h-4 flex items-center justify-center"></i>
              Categorias
              <i className={`ri-arrow-down-s-line text-sm w-4 h-4 flex items-center justify-center transition-transform duration-200 ${catDropdownOpen ? "rotate-180" : ""}`}></i>
            </button>
            {catDropdownOpen && (
              <div className="absolute right-0 mt-2 w-72 bg-white rounded-2xl border border-secondary-200 overflow-hidden shadow-lg max-h-[420px] overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center justify-between px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors whitespace-nowrap"
                    onClick={() => setCatDropdownOpen(false)}
                  >
                    <span className="font-medium">{cat.namePt}</span>
                    <span className="text-xs text-secondary-500 ml-2">{cat.count} links</span>
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* CTA Buttons */}
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-1.5 h-10 px-5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
          >
            hoobuy sheet
            <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-1.5 h-10 px-5 rounded-full border-2 border-secondary-300 text-foreground-800 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-secondary-100 transition-all"
          >
            buy it now
            <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-700 cursor-pointer"
          aria-label="Menu"
        >
          <i className={`${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200 px-4 pb-6 max-h-[80vh] overflow-y-auto">
          <div className="pt-4 space-y-2">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center gap-2 px-4 py-3 rounded-xl text-foreground-800 font-semibold text-sm bg-secondary-50 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line text-base w-5 h-5 flex items-center justify-center"></i>
              Home
            </Link>

            {/* Mobile Categories */}
            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-foreground-800 font-semibold text-sm bg-secondary-50 cursor-pointer whitespace-nowrap"
            >
              <span className="flex items-center gap-2">
                <i className="ri-list-check text-base w-5 h-5 flex items-center justify-center"></i>
                Categorias
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform ${mobileCatOpen ? "rotate-180" : ""}`}></i>
            </button>
            {mobileCatOpen && (
              <div className="pl-4 space-y-1 border-l-2 border-secondary-200 ml-4">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center justify-between px-4 py-2.5 rounded-lg text-sm text-foreground-600 hover:bg-background-100 cursor-pointer whitespace-nowrap"
                  >
                    <span>{cat.namePt}</span>
                    <span className="text-xs text-accent-600 ml-2">{cat.count}</span>
                  </a>
                ))}
              </div>
            )}

            {/* Mobile Guides */}
            <button
              onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
              className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-foreground-800 font-semibold text-sm bg-secondary-50 cursor-pointer whitespace-nowrap"
            >
              <span className="flex items-center gap-2">
                <i className="ri-book-open-line text-base w-5 h-5 flex items-center justify-center"></i>
                Guias de Compra
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform ${mobileGuidesOpen ? "rotate-180" : ""}`}></i>
            </button>
            {mobileGuidesOpen && (
              <div className="pl-4 space-y-1 border-l-2 border-accent-200 ml-4">
                {articleLinks.map((a) => (
                  <Link
                    key={a.slug}
                    to={`/guia/${a.slug}`}
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm text-foreground-600 hover:bg-accent-50 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-article-line text-accent-500 text-xs w-4 h-4 flex items-center justify-center"></i>
                    {a.label}
                  </Link>
                ))}
              </div>
            )}

            {/* Mobile CTAs */}
            <div className="pt-3 space-y-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full h-12 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                hoobuy sheet
                <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full h-12 rounded-full border-2 border-secondary-300 text-foreground-800 text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}